class EdProgress {
    container;

    phrases;

    constructor (container, phrases) {
        if (!container) {
            throw new Error('No valid container for cart progress bar');
        }

        this.container = container;
        this.phrases = phrases;
        this.giftBorder = 99999
        this.progress = 0;
    }

    setProgressValue = total => {
        if (total <= 9900) {
            this.progress = Math.round(33333 / 9900 * total);
        } else if (total < 19900 && total > 9900) {
            this.progress = Math.round((33333 / 5000 * (total - 9900)) + 33333);
        } else if (total >= 19900) {
            this.progress = this.giftBorder;
        }

        this.container.querySelector('progress').value = this.progress;

        this.container.querySelectorAll('.step').forEach( el => {
            el.classList.remove('completed');
        });

        if (this.progress >= 33333) {
            this.container.querySelector('.step1').classList.add('completed');
        }

        if (this.progress >= 66666) {
            this.container.querySelector('.step2').classList.add('completed');
        }

        if (this.progress === this.giftBorder) {
            this.container.querySelector('.step3').classList.add('completed');
        }
    }

    update = (total) => {
        this.setProgressValue(total);
        console.log(this.progress);
        console.log(total);
    }
}

if (typeof window.onEdProgressLoad === 'function') {
    window.onEdProgressLoad();
}
